import graphql__f35390b8b1b66f78b287 from "./__generated__/DeleteProjectDialog_project.graphql.ts";
import graphql__b06ef8fbc50d5189942c from "./__generated__/DeleteProjectDialogMutation.graphql.ts";import * as React from "react";
import {useState} from "react";
import {graphql} from "react-relay";
import Section from "../form/Section";
import Row from "../form/Row";
import FormDialog from "../dialog/FormDialog";
import {useFragment, useRelayEnvironment} from "react-relay/hooks";
import {useNavigate} from "react-router-dom";
import Warning from "../presentational/Warning";
import {useIntl} from "react-intl";
import {useErrorContext} from "../../contexts/ErrorContext";
import {commitMutationWithErrorHandling} from "../../helper/commitMutationWithErrorHandling";

type DeleteProjectDialogProps = {
    queryRef: any,
    handleCloseDialog: () => {}
}

const DeleteProjectDialog: React.FC<DeleteProjectDialogProps> = (props) => {

    const navigate = useNavigate();
    const intl = useIntl();
    const project = useFragment(
        graphql__f35390b8b1b66f78b287,
        props.queryRef
    );
    const [projectNameInput, setProjectNameInput] = useState("");

    const relayEnvironment = useRelayEnvironment();
    const {addError} = useErrorContext();

    const handleSubmission = (input) => {
        commitMutationWithErrorHandling(
            relayEnvironment,
            {
                mutation: graphql__b06ef8fbc50d5189942c,
                variables: {
                    input: input
                },
                onCompleted: (response, errors) => {
                    props.handleCloseDialog();
                    navigate('/projects')
                },
                onError: (error) => {
                    props.handleCloseDialog();
                }
            },
            addError,
            {
                customErrorMessage: intl.formatMessage({id: 'errors.failedToDeleteProject'})
            }
        )
    }

    const initialValues = {
        id: project.id
    }

    const projectDisplayName = project.projectName + (project.projectNumber ? ' (' + project.projectNumber + ')' : '');

    return (
        <FormDialog handleCloseDialog={props.handleCloseDialog}
                    handleSubmission={handleSubmission}
                    initialValues={initialValues}
                    headline={intl.formatMessage({id: 'dialog.DeleteProjectDialog.headline'})}
                    submitLabel={intl.formatMessage({id: 'dialog.DeleteProjectDialog.submitLabel'})}
                    dangerous={true}
                    disabled={projectNameInput !== project.projectName}>
            <Section>
                <Row>
                    <p className="text-gray-900 font-medium">
                        {intl.formatMessage({id: 'dialog.DeleteProjectDialog.confirmMessage'}, {name: projectDisplayName})}
                    </p>
                </Row>
                <Row>
                    <Warning>
                        This will also delete the corresponding project in Kimai, including all potential timesheets.
                    </Warning>
                </Row>
                <Row>
                    <input
                        type="text"
                        placeholder="Enter project name to confirm"
                        value={projectNameInput}
                        onChange={(e) => setProjectNameInput(e.target.value)}
                        className="block w-full shadow-xs sm:text-sm focus:ring-red-500 focus:border-red-500 border-gray-300 rounded-md"
                    />
                </Row>
            </Section>
        </FormDialog>
    )
}

export default DeleteProjectDialog;
